import { z } from "zod";

export const userSchema = z.object({
  name: z
    .string()
    .min(1, "Name is required")
    .max(50, "Name must be less than 50 characters"),
  email: z.string().email("Invalid email address"),
  phoneNumber: z.string().optional(),
  password: z.string().min(6, "Password must be at least 6 characters"),
});

// Export a combined schema to use for full form validation
export const createTenantRequestSchema = z.object({
  user: userSchema,
});

export type CreateTenantRequest = z.infer<typeof createTenantRequestSchema>;
